<template>
<div >
    <b-table
      
      :fields="fields"
      :items="list_order"
      responsive
      striped hover
    >


     
      <template #cell(valor)="data">
        {{  formatPriceR(data.item.amount) }}
      </template>

      <template #cell(status)="data">
        <b-badge block :variant="data.item.status === 2 ? 'success': 'danger'" >
         {{data.item.status === 2 ? "Enviado": "Aberto"}}
        </b-badge>
      </template>
      

      <template #cell(acoes)="data">
       
        <b-button block  variant="gradient-info" 
             @click="copiar(data.item)"
             size="sm"
            >
              Ver
        </b-button>
      </template>

      
    

    </b-table>

</div>

</template>

<script>
import { BTable, BProgress, BBadge,BButton,BRow, BCol,BFormInput,BInputGroup,BInputGroupPrepend } from 'bootstrap-vue'
import VueBarcode from 'vue-barcode';
import qrcode from 'tui-vue-qrcode'
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import { io } from "socket.io-client";
const socket = io('https://api.pagwise.com/orders');
export default {
  components: {
    BTable,
    BProgress,
    BBadge,
    BButton,BRow,BCol,qrcode,BFormInput,BInputGroup,BInputGroupPrepend, VueBarcode
  },
  data() {
    return {
        respostaPix:"",
      // dynamicMask:"#####.#####",
      boleto:false,
      options:{size:350},
      isPix:false,
      show:false,
      resposta:{customer:{}},
      fields: [
        // A virtual column that doesn't exist in items
        { key: 'name', label: 'Banco' }, 
        { key: 'createdAt', label: 'Data Pedido' }, 
        { key: 'completedAt', label: 'Data Efetivado' }, 
        { key: 'valor', label: 'Valor' }, 
        { key: 'status', label: 'Status' }, 
        { key: 'acoes', label: 'Ações' },
    
      ],

    }
  },
    
    computed:{
        list_order() {
        return this.$store.state.estabelecimentos.list_envios
        },
    },
    methods:{
      copiar(value) {
        console.log(value)
        // this.alert(value)
                const el = document.createElement("textarea");
                el.value = value.id;
                document.body.appendChild(el);
                el.select();
                document.execCommand("copy");
                document.body.removeChild(el);
                // this.alert(value)
            },
      alert(item){
        alert(  item.id)
       
      },
      formatPriceR(value) {
        let novo = parseInt(value)
        let val = novo.toFixed(2).replace(".", ",");
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      },
        respostaPixBoleto(data){
            
                // this.respostaPix = data
                if(data.orderId == this.resposta.id){
                    this.$alert(
                    "Pagamento realizado com sucesso",
                    "Parabéns",
                    "success"
                    ).then(
                        this.boleto = false,
                        this.show = false,
                    this.resposta ={customer:{}},
                    this.close_connection()
                    );
                }
                
 
        },
        websocket_conection(orderId){
            socket.on(orderId, this.respostaPixBoleto); 
        },
        close_connection(){
            // socket.disconnect();

        },


      copyToClipboard(){
        
        let textoCopiado = document.getElementById("pixCopiaCola");
        textoCopiado.select();
        textoCopiado.setSelectionRange(0, 99999)
        document.execCommand("copy");
        this.$toast({
            component: ToastificationContent,
            props: {
              title: "Copiado com sucesso",
              icon: "EditIcon",
              variant: "success",
            },
          });
      },
      abrirModalPix(value){
        var url = 'http://localhost:3025/pix?uuid=' + value.id;
      window.open(url , '_blank');
        // this.websocket_conection(value.id)
        // console.log(value)
        // this.resposta = value
        // this.isPix = true
        // this.show = true
      },
      abrirModalBoleto(value){
     var url = 'http://localhost:3025/ordem?uuid=' + value.id;
      window.open(url , '_blank');
        // this.websocket_conection(value.id)
        // console.log(value)
        // this.resposta = value
        // this.boleto = true
        // console.log(this.resposta)
      }

    }
}
</script>

<style scoped>
     
        .boleto {
            text-align: center;
            max-width: 100%; 
            margin-left: auto;
            margin-right: auto; 
        }
        td.BoletoCodigoBanco {
            font-size: 6mm;
            font-family: arial, verdana;
            font-weight: bold;
            FONT-STYLE: italic;
            text-align: center;
            vertical-align: bottom;
            border-bottom: 0.15mm solid #000000;
            border-right: 0.15mm solid #000000;
            padding-bottom: 1mm
        }

        td.BoletoLogo {
            border-bottom: 0.15mm solid #000000;
            border-right: 0.15mm solid #000000;
            text-align: center;
            height: 10mm;

            /*
      max-height:10mm;
      width: auto;
      height: auto;
      */

        }

        td.BoletoLinhaDigitavel {
            font-size: 4 mm;
            font-family: arial, verdana;
            font-weight: bold;
            text-align: center;
            vertical-align: bottom;
            border-bottom: 0.15mm solid #000000;
            padding-bottom: 1mm;
        }

        td.BoletoTituloEsquerdo {
            font-size: 0.2cm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            border-right: 0.15mm solid #000000;
            text-align: left
        }

        td.BoletoTituloDireito {
            font-size: 2mm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            text-align: left
        }

        td.BoletoValorEsquerdo {
            font-size: 3mm;
            font-family: arial, verdana;
            text-align: center;
            border-right: 0.15mm solid #000000;
            font-weight: bold;
            border-bottom: 0.15mm solid #000000;
            padding-top: 0.5mm
        }

        td.BoletoValorDireito {
            font-size: 3mm;
            font-family: arial, verdana;
            text-align: right;
            padding-right: 3mm;
            padding-top: 0.8mm;
            border-bottom: 0.15mm solid #000000;
            font-weight: bold;
        }

        td.BoletoTituloSacado {
            font-size: 2mm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            vertical-align: top;
            padding-top: 0.15mm;
            text-align: left
        }

        td.BoletoValorSacado {
            font-size: 3mm;
            font-family: arial, verdana;
            font-weight: bold;
            text-align: left
        }

        td.BoletoTituloSacador {
            font-size: 2mm;
            font-family: arial, verdana;
            padding-left: 0.15mm;
            vertical-align: bottom;
            padding-bottom: 0.8mm;
            border-bottom: 0.15mm solid #000000
        }

        td.BoletoValorSacador {
            font-size: 3mm;
            font-family: arial, verdana;
            vertical-align: bottom;
            padding-bottom: 0.15mm;
            border-bottom: 0.15mm solid #000000;
            font-weight: bold;
            text-align: left
        }

        td.BoletoPontilhado {
            border-top: 0.3mm dashed #000000;
            font-size: 1mm
        }

        ul.BoletoInstrucoes {
            font-size: 3mm;
            font-family: verdana, arial
        }

        @media print {
            .noprint {
                display: none;
            }

            body {
                background: #fff;
            }
        }

        .cardvalor {
            background-color: #1155d4;
            border-radius: 13px;
            color: #fff;
        }
        .cardvencimento {
            background-color: #1193d4;
            border-radius: 13px;
            color: #fff;    
        }
        .carddescricao {
            background-color: #eef4f6;
            border-radius: 13px;
            color: rgb(56, 52, 52);
        }
        body {
          background-color: #f6f6f6;
        }
    </style>